import { Blockchain } from "@/cuties/model/pet/BlockchainId";
import type { Web3Blockchain } from "@/cuties/model/pet/BlockchainId";

export const chains: Record<number, string> = {
    1: "Ethereum Mainnet",
    4: "Rinkeby Testnet",
    5: "Goerli Testnet",
    42: "Kovan Testnet",
    52: "SCS Mainnet",
    53: "SCS Testnet",
    56: "Binance Smart Chain Mainnet",
    97: "Binance Smart Chain Testnet",
    65: "OKC Testnet",
    66: "OKC Mainnet",
    128: "Heco Chain Mainnet",
    137: "Polygon Mainnet",
    256: "Heco Chain Testnet",
    42262: "Emerald Mainnet",
    42261: "Emerald Testnet",
    80001: "Polygon Testnet",
};

export const currencies: Partial<Record<Web3Blockchain, string>> = {
    [Blockchain.Ethereum]: "ETH",
    [Blockchain.Matic]: "MATIC",
    [Blockchain.Heco]: "HT",
    [Blockchain.Emerald]: "ROSE",
    [Blockchain.Csc]: "CET",
    [Blockchain.Okc]: "OKT",
    [Blockchain.Bsc]: "BNB",
};
